import Api from '@/services/Index';

const approveInformation = async (data) => {
    Api.defaults.baseURL = process.env.VUE_APP_ENDPOINT_STUDENT;
    return Api.post('/course/agreement/wdc-approve-information',data);
}
const save = async (data) => {
    Api.defaults.baseURL = process.env.VUE_APP_ENDPOINT_STUDENT;
    return Api.post('/course/agreement/wdc-approve',data);
}



export default {
    approveInformation,
    save
}
